export class WebStorageKeys {
  // localStorage or sessionStorage
  static hostName: string = "hostName";
  static windowRectangle: string = "windowRectangle";
  static isDeveloperMode: string = "isDeveloperMode";
  static patientSearchHistory: string = "patientSearchHistory";

  // sessionStorage
  static tokenKey = "tokenKey";
  static departmentKey = "departmentKey";
  static userKey = "userKey";
  static configurationKey = "configurationKey";
  static extraConfigurationKey = "extraConfigurationKey";
  static userAuthorityKey = "userAuthorityKey";
  static userDepartmentsKey = "userDepartmentsKey";
  static orderUserKey = "orderUserKey";
  static attendingUserKey = "attendingUserKey";
  static clientIpAddressKey = "clientIpAddressKey";
  static launchedInformationKey = "launchedInformationKey";
  static isNotRestoredKey = "isNotRestoredKey";
  static entryFullPath = "entryFullPath";
  static departmentGroupKey = "departmentGroupKey";
  static isManualCloseableKey = "isManualCloseableKey";
  static referenceableDepartmentGroupsKey = "referenceableDepartmentGroupsKey";
  static isDepartmentGroupScopeEnableKey = "isDepartmentGroupScopeEnableKey";
  static userSelectionKey = "userSelectionKey";
  static postedDataKey = "postedDataKey";
}
